import { Injectable } from '@angular/core';

import { ApiService, AppContext, LogService } from './';
import { Register, Confirm, PersonalInformation, Port, Carrier, Vessel } from './';

declare const AWS: any;
declare const apigClientFactory: any;
declare const AWSCognito: any;

@Injectable()
export class UserService {

  apiService: any = null;

  constructor(private api: ApiService, private app: AppContext, private logger: LogService) {
    this.apiService = api;
  }

  createUser(model: Register): Promise<any[]> {
    let body = {
      email: model.email.toLowerCase(),
      token: model.token,
      coupon: model.coupon,
      planId: model.planId,
      firstName: model.firstName,
      lastName: model.lastName
    };
    return this.api.getApiClient().then(client => this.callCreateUser(client, body));
  }

  callCreateUser(apigClient: any, body: any): Promise<any> {
    return new Promise((resolve, reject) => {
      let params = {};
      let additionalParams = {
        headers: { 'Content-Type': 'application/json' }
      };
      try {
        apigClient.userRegisterPost(params, body, additionalParams)
          .then((result) => {
            resolve(result.data);
          })
          .catch((err) => {
            return reject(err);
          });
      } catch (ex) {
        return reject(ex);
      }
    });
  }

  addPersonalInformation(model: PersonalInformation): Promise<any> {
    let body = {
      firstName: model.firstName,
      lastName: model.lastName,
      business: model.business,
      company: model.company,
      position: model.position,
      country: model.country,
      city: model.city,
      subscribe: model.subscribe
    };

    return this.api.getApiClient().then(client => this.callAddPersonalInformation(client, body));
  }

  callAddPersonalInformation(apigClient: any, body: any): Promise<any> {
    return new Promise((resolve, reject) => {
      let params = {};
      let additionalParams = {
        headers: { 'Content-Type': 'application/json' }
      };
      try {
        apigClient.userInformationPost(params, body, additionalParams)
          .then(result => {
            resolve(result);
          }).catch(err => {
            return reject(err);
          });
      } catch (ex) {
        return reject(ex);
      }
    });
  }

  confirmUser(email: string): Promise<any> {
    return this.api.getApiClient().then(client => this.callConfirmUser(client, email));
  }

  callConfirmUser(apigClient: any, email: string): Promise<any> {
    return new Promise((resolve, reject) => {
      let params = {};
      let body = {
        email: email.toLowerCase()
      };
      let additionalParams = {
        headers: { 'Content-Type': 'application/json' }
      };
      try {
        apigClient.userConfirmPost(params, body, additionalParams)
          .then(result => {
            resolve(result);
          }).catch(err => {
            return reject(err);
          });
      } catch (ex) {
        return reject(ex);
      }
    });
  }

  init() {
    let cognitoUser = this.api.userPool.getCurrentUser();
    if (cognitoUser !== null) {
      this.getProfile();
    }
  }

  checkIfUser(email: string) {
    return this.api.getApiClient().then(client => this.callCheckIfUser(client, email));
  }

  callCheckIfUser(apigClient: any, email: string): Promise<any> {
    return new Promise((resolve, reject) => {
      let params = {
        email: email.toLowerCase()
      };
      let body = {
        email: email.toLowerCase()
      };
      let additionalParams = {
        headers: { 'Content-Type': 'application/json' },
        queryParams: {
          email: email.toLowerCase()
        }
      };
      try {
        apigClient.userConfirmGet(params, body, additionalParams)
          .then(result => {
            resolve(result);
          }).catch(err => {
            return reject(err);
          });
      } catch (ex) {
        return reject(ex);
      }
    });
  }

  getProfile(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.api.getApiClient().then(client => this.callGetProfile(client))
        .then((result: any) => {
          this.logger.log('user.service', 'getProfile result', result);
          this.setProfile(result.data);
          resolve(result.data);
        }).catch((error) => {
          reject(error);
        });
    });
  }

  callGetProfile(apigClient): Promise<any> {
    return new Promise((resolve, reject) => {
      let params = {};
      let body = {};
      let additionalParams = {
        headers: { 'Content-Type': 'application/json' }
      };

      var cognitoIdentityId = this.apiService.getCognitoId();
      let checkAccountStatusPostBody = {
        cognitoId: cognitoIdentityId
      }

      try {
        apigClient.v2CheckAccountStatusPost(params, checkAccountStatusPostBody, additionalParams)
          .then((resultUserProfile) => {
            apigClient.userProfileGet(params, body, additionalParams)
            .then((result) => {
              resolve(result);
            }).catch((err) => this.api.handleError(err));
          }).catch((e) => { });
      } catch (ex) {
        return reject(ex);
      }
    });
  }

  setProfile(data: any) {
    try {
      this.app.setEmail(data.email);

      // **** 

      //this.app.setAccountType(data.account.type);

      this.app.setIsCustomer(data.account.stripeId);

      if (data.limits !== undefined && data.limits !== null) {
        this.app.setMaxSchedules(data.limits.maxSchedules);
      }
      if (data.plan !== undefined && data.plan !== null) {
        this.app.setPlan(data.plan);
        this.app.setBillingInterval(data.plan.interval);
      }

      // TODO: This is a temporary fix due to we can't change linescape-api now, it should be change when the linescape-api is able to be change
      // if (this.app.plan.name === 'Monthly Enterprise 2-6' || this.app.plan.name === 'Monthly Enterprise 7-12' || this.app.plan.name === 'Monthly Enterprise 13-18' ||
      //     this.app.plan.name === 'Yearly Enterprise 2-6' || this.app.plan.name === 'Yearly Enterprise 7-12' || this.app.plan.name === 'Yearly Enterprise 13-18') {
      //   data.account.type = 'Professional';
      // }
      if (this.app.plan.name.includes('Enterprise')) {
        data.account.type = 'Professional';
      }
      if (data.account.coveredByEnterprise == true) {
        data.account.type = 'Professional';
        this.app.isSubEnterprise = true;
      } else {
        this.app.isSubEnterprise = false;
      }
      this.app.setAccountType(data.account.type);
      // ****

    } catch (err) {
      this.logger.log('user.service', 'setProfile', err);
    }

    try {
      if (data !== null && data.favorites !== null) {
        this.setFavorites(data.favorites);
      }
    } catch (err) {
      this.logger.log('user.service', 'setProfile setFavorites', err);
    }

    try {
      let information = new PersonalInformation(data.personalInformation);
      this.app.setPersonalInformation(information);

      if (data.personalInformation == undefined || data.personalInformation.business == undefined) {
        this.app.showPersonalInformation = true;
      }
    } catch (err) {
      // show personal information popup
      this.app.showPersonalInformation = true;
    }
  }

  setFavorites(favorites: any) {
    if (favorites.routes !== undefined) {
      this.app.routes = [];
      this.app.setRoutes(favorites.routes);
    }
    if (favorites.ports !== undefined) {
      this.app.ports = [];
      this.getPorts(favorites.ports.values);
    }
    if (favorites.carriers !== undefined) {
      this.app.carriers = [];
      this.getCarriers(favorites.carriers.values);
    }
    if (favorites.vessels !== undefined) {
      this.app.vessels = [];
      this.getVessels(favorites.vessels.values);
    }
    // not sure if the best practice is to check for undefined or use try-catch
  }

  getVessels(vessels: Array<number>) {
    this.logger.log('user.service', 'getVessels', vessels);
    try {
      for (let current = 0; current < vessels.length; current++) {
        let local = localStorage.getItem('vessel' + vessels[current]);
        if (local === undefined || local === null) {
          this.api.getApiClient().then(client => this.callGetVessel(client, vessels[current]))
            .then((result: Vessel) => {
              this.app.setVessel(result);
            }).catch((err) => {
              this.logger.log('user.service', 'getVessels catch', `vessel: ${vessels[current]} and error: ${err}`);
            });
        } else {
          this.app.setVessel(JSON.parse(local));
        }
      }
    } catch (ex) {
      this.logger.log('user.service', 'getvessels', 'no vessels');
    }
  }

  callGetVessel(apigClient: any, vesselId: number): Promise<Vessel> {
    this.logger.log('user.service', 'callGetVessel', vesselId);
    return new Promise((resolve, reject) => {
      let params = {};
      let body = {};
      let additionalParams = {
        headers: { 'Content-Type': 'application/json' },
        queryParams: {
          id: vesselId
        }
      };
      try {
        apigClient.vesselsGet(params, '', additionalParams)
          .then((result) => {
            this.logger.log('user.service', 'vessel result', result);
            try {
              if (result.data.items[0] == null) {
                throw 'no item returned';
              }

              let vessel = new Vessel(result.data.items[0]);
              resolve(vessel);
            } catch (ex) {
              this.logger.log('user.service', 'vessel null', ex);
              reject(null);
            }
          }).catch((err) => this.api.handleError(err));
      } catch (ex) {
        reject(ex);
      }
    });
  }

  getCarriers(carriers: Array<number>) {
    this.logger.log('user.service', 'getCarriers', carriers);
    try {
      for (let current = 0; current < carriers.length; current++) {
        let local = localStorage.getItem('carrier' + carriers[current]);
        if (local === undefined || local === null) {
          this.api.getApiClient().then(client => this.callGetCarrier(client, carriers[current]))
            .then((result: Carrier) => {
              this.app.setCarrier(result);
            }).catch((err) => {
              this.logger.log('user.service', 'getCarriers catch', err);
            });
        } else {
          this.app.setCarrier(JSON.parse(local));
        }
      }
    } catch (ex) {
      this.logger.log('user.service', 'getCarriers', 'no carriers');
    }
  }

  callGetCarrier(apigClient: any, carrierId: number): Promise<Carrier> {
    this.logger.log('user.service', 'callGetCarrier', carrierId);
    return new Promise((resolve, reject) => {
      let params = {};
      let body = {};
      let additionalParams = {
        headers: { 'Content-Type': 'application/json' },
        queryParams: {
          id: carrierId
        }
      };
      try {
        apigClient.carriersGet(params, '', additionalParams)
          .then((result) => {
            this.logger.log('user.service', 'carrier result', result);
            try {
              if (result.data.items[0] == null) {
                throw 'no item returned';
              }

              let carrier = new Carrier(result.data.items[0]);
              resolve(carrier);
            } catch (ex) {
              this.logger.log('user.service', 'carrier null', ex);
              reject(null);
            }
          }).catch((err) => this.api.handleError(err));
      } catch (ex) {
        reject(ex);
      }
    });
  }

  getPorts(ports: Array<number>) {
    this.logger.log('user.service', 'getPorts', ports);
    try {
      for (let current = 0; current < ports.length; current++) {
        let local = localStorage.getItem('port' + ports[current]);
        if (local === undefined || local === null) {
          this.api.getApiClient().then(client => this.callGetPort(client, ports[current]))
            .then((result: Port) => {
              this.app.setPort(result);
            }).catch((err) => {
              this.logger.log('user.service', 'getPorts catch', `port: ${ports[current]} and error: ${err}`);
            });
        } else {
          this.app.setPort(JSON.parse(local));
        }
      }
    } catch (ex) {
      this.logger.log('user.service', 'getPorts', 'no ports');
    }
  }

  callGetPort(apigClient: any, portId: number): Promise<Port> {
    this.logger.log('user.service', 'callGetPort', portId);
    return new Promise((resolve, reject) => {
      let params = {};
      let body = {};
      let additionalParams = {
        headers: { 'Content-Type': 'application/json' },
        queryParams: {
          id: portId
        }
      };
      try {
        apigClient.portsGet(params, '', additionalParams)
          .then((result) => {
            this.logger.log('user.service', 'port result', result);
            try {
              if (result.data.items[0] == null) {
                throw 'no item returned';
              }

              let port = new Port(result.data.items[0]);
              resolve(port);
            } catch (ex) {
              this.logger.log('user.service', 'port null', ex);
              reject(null);
            }
          }).catch((err) => this.api.handleError(err));
      } catch (ex) {
        reject(ex);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/user.service.ts